var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnpaidLeave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71834 10.315C8.71834 6.90571 2.433 7.12834 2.433 5.06996C2.433 4.07366 3.3862 3.58706 4.49182 3.58706C6.35112 3.58706 6.68218 4.78156 7.52429 4.78156C8.12065 4.78156 8.40772 4.40606 8.40772 3.98522C8.40772 3.00714 6.92482 2.2668 5.50279 2.01039V1.06652C5.50279 0.477711 5.02641 0 4.43716 0C3.84747 0 3.37064 0.477711 3.37064 1.06652V2.04372C1.82019 2.39656 0.486599 3.47196 0.486599 5.22505C0.486599 8.49971 6.77106 8.36728 6.77106 10.6674C6.77106 11.4642 5.90851 12.261 4.49182 12.261C2.36723 12.261 1.65933 10.8229 0.796334 10.8229C0.375948 10.8229 0 11.1767 0 11.7099C0 12.5569 1.4198 13.5763 3.37198 13.8612L3.37064 13.8679V14.933C3.37064 15.5223 3.84835 16 4.43761 16C5.02641 16 5.50368 15.5223 5.50368 14.933V13.8679C5.50368 13.8554 5.49746 13.8456 5.49657 13.8345C7.25321 13.5066 8.71834 12.3614 8.71834 10.315Z",
    fill: "#292F33"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.25,
    cy: 12.25,
    r: 3,
    fill: "white",
    stroke: "#DD2E44",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 14.25L10.25 10.25",
    stroke: "#DD2E44",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpaidLeave);
export default __webpack_public_path__ + "static/media/unpaid-leave.2ca1f4b95a85c2ad20ae408ea50ddeda.svg";
export { ForwardRef as ReactComponent };